<div class="modal-header">
  <h5 class="modal-title">{{ 'words.customizeColumns' | translate }}</h5>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>

<div class="modal-body">
  <div class="d-flex" style="height: 100%">
    <!-- Columna Ocultas -->
    <div class="d-flex flex-column me-3 flex-grow-1">
      <h5>{{ 'words.hiddenColumns' | translate }}</h5>
      <input
        class="form-control mb-2"
        [(ngModel)]="hiddenSearchTerm"
        placeholder="{{ 'words.search' | translate }}"
      />

      <div class="form-check mb-2">
        <input
          type="checkbox"
          class="form-check-input"
          [checked]="
            isAllSelected(
              filtered(hiddenColumns, hiddenSearchTerm),
              selectedHidden
            )
          "
          (change)="
            onToggleSelectAll(
              $event,
              filtered(hiddenColumns, hiddenSearchTerm),
              selectedHidden
            )
          "
        />
        <label class="form-check-label">{{
          'words.selectAll' | translate
        }}</label>
      </div>

      <div
        class="list-container"
        id="hiddenList"
        cdkDropList
        [cdkDropListData]="hiddenColumns"
        [cdkDropListConnectedTo]="['visibleList']"
        (cdkDropListDropped)="onTransfer($event)"
      >
        <div
          class="drag-hint"
          *ngIf="filtered(hiddenColumns, hiddenSearchTerm).length === 0"
        >
          {{ 'words.dragToShow' | translate }}
        </div>

        <div
          *ngFor="let col of filtered(hiddenColumns, hiddenSearchTerm)"
          cdkDrag
          class="drag-item"
        >
          <input
            type="checkbox"
            class="form-check-input me-2"
            [checked]="isSelected(col, selectedHidden)"
            (change)="toggleSelection(col, selectedHidden)"
          />
          <i class="fa fa-bars handle"></i> {{ col.name ?? '' | translate }}
        </div>
      </div>
    </div>

    <!-- Botones Centrales flotantes -->
    <div
      class="d-flex flex-column justify-content-center align-items-center px-2"
      style="width: 40px"
    >
      <button
        class="icon-button mb-3"
        (click)="moveSelectedToVisible()"
        [disabled]="selectedHidden.size === 0"
      >
        <i class="fa fa-chevron-right"></i>
      </button>

      <button
        class="icon-button"
        (click)="moveSelectedToHidden()"
        [disabled]="selectedVisible.size === 0"
      >
        <i class="fa fa-chevron-left"></i>
      </button>
    </div>

    <!-- Columna Visibles -->
    <div class="d-flex flex-column ms-3 flex-grow-1">
      <div class="d-flex align-items-center gap-2 mb-1">
        <h5 class="mb-0">{{ 'words.visibleColumns' | translate }}</h5>
        <i
          class="fa fa-info-circle text-primary"
          ngbTooltip="{{ 'words.reorderColumnsHelp' | translate }}"
          tooltipClass="custom-tooltip"
          placement="right"
        ></i>
      </div>
      <input
        class="form-control mb-2"
        [(ngModel)]="visibleSearchTerm"
        placeholder="{{ 'words.search' | translate }}"
      />

      <div class="form-check mb-2">
        <input
          type="checkbox"
          class="form-check-input"
          [checked]="
            isAllSelected(
              filtered(visibleColumns, visibleSearchTerm),
              selectedVisible
            )
          "
          (change)="
            onToggleSelectAll(
              $event,
              filtered(visibleColumns, visibleSearchTerm),
              selectedVisible
            )
          "
        />
        <label class="form-check-label">{{
          'words.selectAll' | translate
        }}</label>
      </div>

      <div
        class="list-container"
        id="visibleList"
        cdkDropList
        [cdkDropListData]="visibleColumns"
        [cdkDropListConnectedTo]="['hiddenList']"
        (cdkDropListDropped)="onDropVisible($event); onTransfer($event)"
      >
        <div
          class="drag-hint"
          *ngIf="filtered(visibleColumns, visibleSearchTerm).length === 0"
        >
          {{ 'words.dragToReorderOrHide' | translate }}
        </div>

        <div
          *ngFor="let col of filtered(visibleColumns, visibleSearchTerm)"
          cdkDrag
          class="drag-item"
        >
          <input
            type="checkbox"
            class="form-check-input me-2"
            [checked]="isSelected(col, selectedVisible)"
            (change)="toggleSelection(col, selectedVisible)"
          />
          <i class="fa fa-bars handle"></i> {{ col.name ?? '' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="cancel()">
    {{ 'btn.cancel' | translate }}
  </button>
  <button type="button" class="btn btn-warning" (click)="reset()">
    {{ 'btn.reset' | translate }}
  </button>
  <button
    type="button"
    class="btn btn-secondary"
    [disabled]="!isDirty"
    (click)="save()"
  >
    {{ 'btn.save' | translate }}
  </button>
</div>
